import { GET_ASSET_IMAGES, REMOVE_ASSET_IMAGES } from '../../types';

const initialState = { images: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ASSET_IMAGES:
            return {
                ...state,
                images: [...payload]
            };
        case REMOVE_ASSET_IMAGES:
            return {
                ...state,
                images: []
            };
        default:
            return state;
    }
}